import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { releaseStatusOptions } from '@/shared/constants/statusOptions';
import { getDetailLabel } from '@/shared/copy/details';
import type { ReleaseStatus } from '@flowqa/shared';

export type ReleasesSortKey = 'name' | 'status' | 'plannedFor' | 'releasedAt';
export type ReleasesSortDirection = 'asc' | 'desc';

export const releasesDefaultSortKey: ReleasesSortKey = 'plannedFor';
export const releasesDefaultSortDirection: ReleasesSortDirection = 'desc';

export const releasesSortFieldMap: Record<ReleasesSortKey, string> = {
  name: 'name',
  status: 'status',
  plannedFor: 'plannedFor',
  releasedAt: 'releasedAt',
};

export const releasesTableDefinition: TableDefinition<ReleasesSortKey, ReleaseStatus> =
  createTableDefinition({
    title: 'Releases',
    searchAriaLabel: 'Search releases',
    columns: [
      { field: 'name', label: 'Release', mandatory: true, defaultVisible: true },
      { field: 'status', label: getDetailLabel('status'), defaultVisible: true },
      { field: 'features', label: 'Features', defaultVisible: true },
      { field: 'latestSuiteResults', label: 'Latest Suites', defaultVisible: true },
      { field: 'latestTestResults', label: 'Latest Tests', defaultVisible: true },
      { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
    ],
    defaultSortKey: releasesDefaultSortKey,
    defaultSortDirection: releasesDefaultSortDirection,
    sortOptions: [
      { key: 'releasedAt', label: 'Released At' },
      { key: 'plannedFor', label: 'Planned For' },
      { key: 'status', label: getDetailLabel('status') },
      { key: 'name', label: 'Release' },
    ],
    sortFieldMap: releasesSortFieldMap,
    statusOptions: releaseStatusOptions.map((option) => ({
      value: option.value as ReleaseStatus,
      label: option.label,
    })),
  });
